import { render, staticRenderFns } from "./StatistiquesCharts.vue?vue&type=template&id=7a960072&scoped=true"
import script from "./StatistiquesCharts.vue?vue&type=script&lang=js"
export * from "./StatistiquesCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a960072",
  null
  
)

export default component.exports